import React, { useEffect, useState } from "react"
import { apiGet } from "../api"
import serverName from "../serverName"
import logo from "../logo.svg";
import {motion} from "framer-motion";

export default function Admins() {
    const [groups, setGroups] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        apiGet("/admins.php").then(r => {
            if (r.ok) setGroups(r.groups)
            setLoading(false)
        })
    }, [])

    if (loading) {
        return (
            <div className="w-full flex flex-col items-center justify-center py-32 gap-4 text-white/70">
                <div className="h-10 w-10 border-4 border-white/20 border-t-white rounded-full animate-spin" />
                <div className="text-lg tracking-wide">Načítám…</div>
            </div>
        )
    }


    return (
        <div className="max-w-5xl mx-auto px-6 py-16">
            <motion.h1
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                className="text-center text-5xl font-extrabold mb-14 bg-gradient-to-b from-white to-white/50 bg-clip-text text-transparent tracking-wide"
            >
                {serverName} Team
            </motion.h1>

            {groups.map(g => (
                <section key={g.key} className="mb-12">
                    <div className="flex items-center gap-3 mb-6">
                        <span className="inline-block w-2.5 h-2.5 rounded-full" style={{ background: g.color }} />
                        <h2 className="text-xl font-semibold">{g.label}</h2>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                        {g.members.map(a => (
                            <div key={a.id} className="bg-white/5 border border-white/10 rounded-2xl p-4 flex items-center gap-4 hover:border-white/20 hover:-translate-y-0.5 transition">
                                <img src={a.avatar} alt="" className="w-14 h-14 rounded-full object-cover flex-shrink-0" />
                                <div className="min-w-0">
                                    <div className="font-semibold truncate">{a.name}</div>
                                    <div className="mt-1 text-xs">
                                        <span className="px-2 py-0.5 rounded-md" style={{ color: g.color }}>
                                          <i className="fox-icon fox-icon-amnesia"></i> {a.roleLabel}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            ))}

            {!groups.length && <div className="text-center text-white/50">Není tu nikdo s admin rolí.</div>}
        </div>
    )
}
